<template>

  <div class="container">
    <form class="needs-validation" id="login-form" @submit.prevent="validateLoginForm" data-toggle="validator" novalidate>
      <div class="col-12 col-lg-6 center-align">
        <div class="form-group-container">

          <h1 class="page-title text-center icon-title"><span class="icon-circle center"><i class="fa fa-lock" aria-hidden="true"></i></span><span>Logged out!</span> </h1>

          <div class="col-12 col-md-12 center-align">
            <p class="text-center">You have sucessfully logged out.</p>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { authMethods, authComputed, authMutations } from "@/state/helpers";
import commonMixin from "@/mixins/commonMixin";

export default {
  name: "Logout",
  mixins: [commonMixin],
  data() {
    return {
      username: "",
      password: ""
    }
  },
  computed: {
    ...authComputed
  },
  methods: {
    ...authMethods
  },
  mounted() {
    this.LOGOUT();
    this.scrollToTop("login-form");
  }

}
</script>

<style scoped>
</style>